export default "__VITE_ASSET__BAX7fHfj__"